/*
 * API
 * needLoading: { Boolean } 是否需要请求加载时的loading组件
 */
import service from '@/utils/request'

const info = params => {
  return service.get('/api/info', { params: params, needLoading: true, opacity: false, delay: 3000 })
}
const refresh = body => {
  return service.post('/api/refresh', body, { needLoading: true, opacity: true })
}
const flip = body => {
    return service.post('/api/flip', body, { needLoading: true, opacity: true })
}
const history = params => {
    return service.get('/api/history', { params: params, needLoading: true, opacity: true })
}
const policyCheck = body => {
  return service.post('/api/policy_check', body, { needLoading: true, opacity: true })
}
const googlePolicyCheck = (body) => {
  return service.post('/api/google_analytics_check', body, {
    needLoading: true,
    opacity: true,
  })
}
export default {
    info,
    refresh,
    flip,
    history,
  policyCheck,
  googlePolicyCheck
}



// WEBPACK FOOTER //
// ./src/api/index.js